import {SliderArrow} from 'components/atoms/LinksAndButtons/SliderArrow';
import * as React from 'react';
import {useEffect, useState} from 'react';

import './style.scss';
import {SearchResult} from "features/search/types";

interface Props {
    searchResults: SearchResult[];
    counterAffix?: string;
    children?: React.ReactNode;
}

export const CardSwitcher: React.FunctionComponent<Props> = ({searchResults, counterAffix, children}) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    useEffect(() => {
        setActiveIndex(0);
    }, [children]);

    const nextIndex = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();

        setActiveIndex(activeIndex === searchResults.length - 1 ? 0 : activeIndex + 1);
    };

    const prevIndex = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();

        setActiveIndex(activeIndex === 0 ? searchResults.length - 1 : activeIndex - 1);
    };

    const modifyChildren = (child, index) => {
        if(activeIndex === index) {
            return (
                <div className="card-switcher__item card-switcher__item--active">
                    {child}
                </div>
            )
        } else {
            return (
                <div className="card-switcher__item">
                    {child}
                </div>
            )
        }
    };

    return (
        <div className="card-switcher">
            {React.Children.map(children, (child, index) => modifyChildren(child, index))}

            <div className="card-switcher__navigation">
                <SliderArrow className="slick-arrow" small onClick={prevIndex} />
                <span>{`${activeIndex + 1} / ${searchResults.length}`} {counterAffix && counterAffix}</span>
                <SliderArrow className="slick-arrow" small onClick={nextIndex} next />
            </div>
        </div>
    )
};
